import { AutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin';
import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin';

import { isYoutubeUrlValid } from 'lib/string';

const REGEX =
  /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const matchers = [
  (text) => {
    const match = REGEX.exec(text);

    if (match === null) {
      return null;
    }

    const fullMatch = match[0];

    // Manually handle YT videos, inserting directly a iframe
    if (isYoutubeUrlValid(fullMatch)) {
      return null;
    }

    return {
      index: match.index,
      length: fullMatch.length,
      text: fullMatch,
      url: fullMatch.startsWith('http') ? fullMatch : `https://${fullMatch}`,
      attributes: { rel: 'noopener noreferrer', target: '_blank' },
    };
  },
];

const LinkPlugin = () => (
  <>
    <LexicalLinkPlugin />
    <AutoLinkPlugin matchers={matchers} />
  </>
);

export default LinkPlugin;
